import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <ul className="social-icons">
          <li>
            <a href="https://x.com/AI_Backrooms" target="_blank" rel="noopener noreferrer" className="icon-link">
              <svg 
                width="40" 
                height="40" 
                viewBox="0 0 1200 1227" 
                xmlns="http://www.w3.org/2000/svg"
                className="social-icon x-logo"
              >
                <path 
                  d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href="https://www.basedbrains.xyz/" target="_blank" rel="noopener noreferrer" className="icon-link">
              <svg 
                width="40" 
                height="40" 
                viewBox="0 0 624.29 743.23" 
                xmlns="http://www.w3.org/2000/svg"
                className="social-icon based-logo"
              >
                <path 
                  className="cls-1" 
                  d="m316.6,0c131.36,0,287.41,39.29,287.41,199.84,0,63.99-28.07,124.62-87.57,153.81,71.85,29.19,107.78,99.92,107.78,175.14,0,167.29-121.25,214.44-267.2,214.44H0V0h316.6Zm-179.63,49.4H49.4v644.43h87.57V49.4Zm286.29,13.47c-20.21-7.86-44.91-13.47-66.24-13.47h-170.65v282.92h162.79c24.7,0,49.4-1.12,74.1-3.37V62.87Zm0,322.22c-24.7-2.24-49.4-3.37-74.1-3.37h-162.79v312.11h171.77c21.33,0,43.79-3.37,65.12-8.98v-299.76Zm49.4-57.26c57.26-25.82,81.96-60.63,81.96-125.74,0-60.63-28.07-102.17-81.96-129.11v254.85Zm0,357.02c74.1-26.95,102.17-76.34,102.17-153.81,0-66.24-34.8-129.11-102.17-144.83v298.64Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;